import { Badge, BadgeProps } from '@chakra-ui/react';
import { GuideBlurb } from '../api/guides/getGuides.api';
import { useLocalization } from '~/framework';

export function isArchived(guide: GuideBlurb): boolean {
   return guide.flags ? guide.flags.find(flag => flag === 'GUIDE_ARCHIVED') !== undefined : false;
}

export function ArchivedGuideBadge({ ...badgeProps }: BadgeProps) {
   const { _js } = useLocalization();
   return (
      <Badge colorScheme="red" {...badgeProps}>
         {_js('Archived')}
      </Badge>
   );
}
